import { DayOfWeekMismatchModelBase } from "./DayOfWeekMismatchModel.base"


/* A graphql query fragment builders for DayOfWeekMismatchModel */
export { selectFromDayOfWeekMismatch, dayOfWeekMismatchModelPrimitives, DayOfWeekMismatchModelSelector } from "./DayOfWeekMismatchModel.base"

/**
 * DayOfWeekMismatchModel
 */
export const DayOfWeekMismatchModel = DayOfWeekMismatchModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self))
    }
  }))
